module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-registration"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Plate"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.plate),
      expression: "body.plate"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.plate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "plate", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Model"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.model),
      expression: "body.model"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "model", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Odometer"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.odometer),
      expression: "body.odometer"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.odometer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "odometer", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Color"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.color),
      expression: "body.color"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "color", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "small-12-large-6 columns"
  }, [_c('label', [_vm._v("Category"), _c('selectize-category', {
    on: {
      "optionSelected": _vm.selectCategory
    }
  })], 1), _c('label', [_vm._v("Fuel type"), _c('fuel-type-select', {
    on: {
      "fuelTypeSelected": _vm.selectFuel
    }
  })], 1), _c('label', [_vm._v("Brand"), _c('selectize-vehicle-brand', {
    on: {
      "optionSelected": _vm.selectBrand
    }
  })], 1), _c('label', [_vm._v("Picture"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.picture),
      expression: "body.picture"
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.body.picture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "picture", $event.target.value)
      }
    }
  })]), _c('kepler-file-upload', {
    attrs: {
      "selectedPrefix": "vehicles",
      "selectedVisibility": "public"
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.formSubmit
    }
  }, [_vm._v("Create")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e5985d3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateVehicle.vue
// module id = 2365
// module chunks = 1